// @flow

import { Icon, Row, Text } from '@8base/boost';
import React from 'react';
import styled from '@emotion/styled';

type CollapseTitleProps = {
  toggleOpen: () => void;
  isOpen: boolean;
  title: string;
  style?: any;
}


const StyledIcon = styled(Icon)(props => ({
  transform: props.isOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
  transition: 'all .3s ease',
}));

const StyledRow = styled(Row)`
  & > .CollapseTitle-Text {
    transition: color .3s ease;
  }

  &:hover > * {
    color: ${({ theme }) => theme.COLORS.BLUE_20}
  }
`;

export const CollapseTitle = ({
  toggleOpen,
  isOpen,
  title,
  style,
}: CollapseTitleProps) => {

  return (
    <StyledRow cursor="pointer" alignItems="center" onClick={ toggleOpen } style={ style } stretch >
      <Text kind="overline-2" className="CollapseTitle-Text" >{ title }</Text>
      <StyledIcon isOpen={ isOpen } name="ChevronDown" size="xs" color="LIGHT_TEXT_COLOR" />
    </StyledRow>
  );
};
